import { Injectable } from '@angular/core';
import { QueryResultT } from '@core/types/query-result-t';
import { EntityQuery } from 'breeze-client';
import { from, Observable } from 'rxjs';
import { BreezeBaseService } from './breeze-base.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService extends BreezeBaseService {
  public constructor() {
    super('project', 'project');
  }

  public getProjectCodesByUserCode(userCode: string): Observable<string[]> {
    const query = EntityQuery.from('GetProjectCodesByUserCode').withParameters({ userCode });

    return from(this.em.executeQuery(query).then((response: QueryResultT<string>) => response.results));
  }
}
